// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__og37l","svg":"styles_svg__PBGem","captionZone":"styles_captionZone__Ryp+y","captionZoneLabel":"styles_captionZoneLabel__hMPQP"};